import React from "react";
import { PokemonContext } from "../context/pokemonContext";
import { typeColors } from "../colors/typeColor";

const PokemonStats = () => {

    const { pokemon } = React.useContext(PokemonContext);

    return (
        <div className="stats-box">

            <h2 className="text-center">Stats</h2>

            {
                pokemon.stats.map((stat, index) => {
                    return (
                        <div 
                            key={index}
                            className="stats-range row"
                        >

                            <div className="col-4">
                                <span>{stat.stat.name}</span>
                            </div>

                            <div className="col-8">
                                <div className="progress">
                                    <div 
                                        className="progress-bar" 
                                        style={{
                                            backgroundColor: typeColors[pokemon.types[pokemon.types.length-1].type.name],
                                            width: stat.base_stat+'%', 
                                        }}
                                    ><small>{stat.base_stat}</small></div>
                                </div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
}

export default PokemonStats;